<template>
  <transition name="modal-fade">
    <div class="modal-window">
      <div class="close-btn-holder">
        <button
          type="button"
          class="btn-close-big"
          @click="close"
          aria-label="Close Modal">
          Close Modal
        </button>
        <span class="close-btn-text">close</span>
      </div>
      <div class="modal-holder" :class="[value.positionClass, value.sizeClass, value.styleClass]">
        <div class="circle-heading">{{ value.title }}</div>
        <div class="modal-block">
          <h3 class="modal-header">{{ value.title }}</h3>
          <button
            type="button"
            class="btn-close-small"
            @click="close"
            aria-label="Close Modal">
            Close Modal
          </button>
          <p class="modal-content">{{ value.content }}</p>
          <a :href="value.linkUrl" class="modal-link-more" target="_blank">Explore example</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'WindowModal',
  props: {
    value: { required: true },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modals/WindowModal.vue